module.exports = "/packs/course-small-logo-ci-d51c439ccc9bb711beca2e893bbcca23.png";